import {Provider} from '@angular/core';
import {UuidProvider} from '@shared/infrastructure/uuid/uuid.provider';
import {FileContextAdapter} from '@shared/infrastructure/context/file-context.adapter';
import {FileStorageContextPort} from '@shared/application/ports/context/file-storage-context.port';

export const FileContextProvider: Provider[] = [
  UuidProvider,
  {
    provide: FileStorageContextPort,
    useClass: FileContextAdapter
  }
]
